import React from 'react';
type EmphasisLinesProps = {
  lines: string[];
  className?: string;
};
export function EmphasisLines({
  lines,
  className = ''
}: EmphasisLinesProps) {
  return <div className={`text-center font-display text-2xl font-extrabold uppercase leading-tight tracking-wide md:text-3xl ${className}`} data-id="element-30" data-mp="3njrkif8ae9sl">
      {lines.map((line, i) => <p key={line} className={i === lines.length - 1 ? 'text-accent-400' : 'text-white'} data-id="element-31" data-mp="17b7fypx0a65" data-mpi={i}>
          {line}
        </p>)}
    </div>;
}